import { useMemo } from 'react';
import { shallowEqual, useSelector } from 'react-redux';

import {
  selectDessemDataAnalisada,
  selectDessemCenario,
} from 'redux/reducers/relatoriosDessemReducer';
import { DessemSecaoParams } from 'types/Relatorios/Dessem';

/**
 * Deriva os params compartilhados das abas DESSEM (`data_rodada` ISO +
 * `cenario`) a partir do slice. `useMemo` sobre os primitivos
 * `[ano, mes, dia, cenario]` (NÃO sobre o objeto do selector, que retorna
 * nova ref a cada render) e devolve referência estável — evita refetch RTK Query.
 * O `shallowEqual` compara a data campo a campo: sem ele, toda ação que muda o
 * estado (as do RTK Query, por exemplo) desenharia de novo as seções.
 */
export default function useDessemSecaoParams(): DessemSecaoParams {
  const { ano, mes, dia } = useSelector(selectDessemDataAnalisada, shallowEqual);
  const cenario = useSelector(selectDessemCenario);

  return useMemo(() => {
    const mm = String(mes).padStart(2, '0');
    const dd = String(dia).padStart(2, '0');
    return { data_rodada: `${ano}-${mm}-${dd}`, cenario };
  }, [ano, mes, dia, cenario]);
}
